<template>
    <div v-bind:class="{ 'tw-header__section tw-text--right' : isLargeScreen }">
        <ul class="tw-breadcrumbs" v-bind:class="{ 'tw-responsive__sm--hide tw-responsive__xs--hide tw-responsive__xxs--hide' : isLargeScreen, 'tw-text--center tw-responsive__sm--visible' : !isLargeScreen }">
            <li v-for="stage in stages" :key="stage._id" v-if="stage.isRouteAvailable" v-bind:class="{'tw-breadcrumbs--active': currentStage.id === stage.id}" v-on:click='navigateBack()' class='tw-breadcrumbs--counter'>
                <span>{{ stage.breadcrumb }}</span>
                <font-awesome-icon icon="chevron-right" />
            </li>
            <li v-if="isLargeScreen && currentStage.id === 'tickets'">
                <buy-now-button v-bind:buttonPosition="'header-button-lg'"></buy-now-button>
            </li>
            <li v-if="!isLargeScreen">
                <span>
                    <img src="https://static.designmynight.com/images/payment-types-mini.png" alt="Debit and credit cards accepted" width="60">
                </span>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import CartManager from '../../../services/CartManager';
    import BuyNowButton from '../buy-now-button/BuyNowButton.vue';
    import TicketWidgetComponent from "../../TicketWidgetComponent";

    //fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

    library.add(faChevronRight);

    @Component({
        components: {
            BuyNowButton,
            FontAwesomeIcon
        },
        watch: {
            '$route' (to, from) {
                this.$root.$data.config.currentStage = to.meta.stage;
                this.$root.$data.config.fromStage = from;
                this.$root.$emit('routeChanged', from);
            }
        },
    })

    export default class BreadCrumbs extends TicketWidgetComponent {
        @Prop() public isLargeScreen!: boolean;

        current: string = 'initial';
        stages: (any[]) = [];
        selectedTotal: number = 0;
        selectedCost: number = 0;

        /**
        * @desc when mounted, grab the stages and initiualize an evnet listener
        */
        mounted() {
            this.stages = this.$root.$data.stages;
        }

        /**
        * @desc if the user clicks the previous breadcrumb, it will navigate back one.
        */
        navigateBack() {
            this.$router.go(-1);

            this.$root.$data.config.currentStage = this.$route.meta!.stage;
        }
    }
</script>